import {isI18nDebugEnabled} from '../../utils/isI18nDebugEnabled';

export function getRowDebugText(rowKey: string): string {
  return isI18nDebugEnabled() ? `rowKey=${rowKey}` : '';
}
